"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeField = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const date_fns_1 = __importDefault(require("@date-io/date-fns"));
const date_fns_2 = require("date-fns");
const MuiPickersUtilsProvider_1 = __importDefault(require("@material-ui/pickers/MuiPickersUtilsProvider"));
const TimePicker_1 = require("@material-ui/pickers/TimePicker");
const locale_context_1 = require("../../common/locale/locale-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const date_utils_1 = require("../../utils/date-utils");
const time_field_styles_1 = require("./time-field-styles");
function TimeField({ form, disabled, minTime: minTimeString, maxTime: maxTimeString, value, onChange, }) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    const intl = react_intl_1.useIntl();
    const { locale } = react_1.useContext(locale_context_1.LocaleContext);
    const [internalValue, setInternalValue] = react_1.useState(() => date_utils_1.parseISOTimeSafe(value));
    const minTime = date_utils_1.parseISOTimeSafe(minTimeString);
    const maxTime = date_utils_1.parseISOTimeSafe(maxTimeString);
    const isError = event_callback_hook_1.useEventCallback((date) => {
        if (date != null) {
            if (!date_fns_2.isValid(date)) {
                return true;
            }
            else if (maxTime && date > maxTime) {
                return true;
            }
            else if (minTime && date < minTime) {
                return true;
            }
        }
        return false;
    });
    // update internal representation if supplied from above
    react_1.useEffect(() => setInternalValue(date_utils_1.parseISOTimeSafe(value)), [value]);
    // stores the new value in internal storage and propagates above only null and valid dates
    const handleChange = event_callback_hook_1.useEventCallback((date) => {
        setInternalValue(date);
        if (date == null) {
            onChange(null);
        }
        else if (!isError(date)) {
            onChange(date_utils_1.formatISOTime(date));
            console.log('time', date_utils_1.formatISOTime(date));
        }
    });
    const classes = time_field_styles_1.useStyles();
    return (react_1.default.createElement(MuiPickersUtilsProvider_1.default, { utils: date_fns_1.default, locale: locale.dateFnsLocale },
        react_1.default.createElement(TimePicker_1.KeyboardTimePicker, { InputProps: {
                classes: {
                    root: classes.root,
                    input: classes.input,
                },
            }, inputProps: {
                form,
            }, autoOk: true, ampm: false, variant: "dialog", fullWidth: true, disabled: disabled, value: internalValue, format: locale.timeFormat, onChange: handleChange, InputAdornmentProps: {
                classes: {
                    root: clsx_1.default({
                        [classes.addorment]: !disabled,
                        [classes.dissabledAddorment]: disabled,
                    }),
                },
            }, cancelLabel: intl.formatMessage({
                id: 'EAS_DATEPICKER_BUTTON_CANCEL',
                defaultMessage: 'Zrušit',
            }), okLabel: intl.formatMessage({
                id: 'EAS_DATEPICKER_BUTTON_OK',
                defaultMessage: 'Potvrdit',
            }), 
            // don't show error messages only error underline
            invalidDateMessage: "", maxDateMessage: "", minDateMessage: "", error: disabled ? false : isError(internalValue) })));
}
exports.TimeField = TimeField;
//# sourceMappingURL=time-field.js.map